import script from "./BaseSpin.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSpin.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSpin.vue?vue&type=style&index=0&id=02a111bd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a111bd"]])

export default __exports__